// utils/priceUtils.js

export function priceForService({
  svc,
  visitType,
  isExtraSlot,
  psdf,
  isIncorrectChild = false,
}) {
  if (!svc || psdf) {
    return 0;
  }

  const vt = isExtraSlot
    ? 'extra'
    : visitType === 'secondary'
      ? 'secondary'
      : 'primary';

  // Normal prices
  const primary = Number(svc?.priceWithDiscount ?? 0) || 0;
  const secondary = Number(svc?.secondaryDiscountEur ?? 0) || 0;
  const extra = Number(svc?.extraPrice ?? 0) || 0;

  // Prices without discount card (for incorrect child)
  const primaryNoCard = Number(svc?.priceWithDiscountWithoutCard ?? 0) || 0;
  const secondaryNoCard =
    Number(svc?.priceWithDiscountWithoutCardSecondary ?? 0) || 0;
  const extraNoCard = Number(svc?.priceWithDiscountWithoutCardExtra ?? 0) || 0;
  let result;
  if (vt === 'extra') {
    result = isIncorrectChild ? extraNoCard : extra;
  } else if (vt === 'secondary') {
    result = secondary
      ? isIncorrectChild
        ? secondaryNoCard
        : secondary
      : isIncorrectChild
        ? primaryNoCard
        : primary;
  } else {
    result = isIncorrectChild ? primaryNoCard : primary;
  }
  return result;
}

export function priceForServiceBeforeDiscount({
  svc,
  visitType,
  isExtraSlot,
  psdf,
}) {
  if (!svc || psdf) return undefined;

  const vt = isExtraSlot
    ? 'extra'
    : visitType === 'secondary'
      ? 'secondary'
      : 'primary';

  let value;

  if (vt === 'extra') {
    value = Number(svc?.extraPrice) || undefined;
  } else if (vt === 'secondary') {
    value = Number(svc?.secondaryPrice) || undefined;
  } else {
    value = Number(svc?.price) || undefined;
  }

  return value > 0 ? value : undefined;
}

export function sumAdditionalServices(additionalServices = []) {
  if (!Array.isArray(additionalServices) || !additionalServices.length)
    return 0;
  return additionalServices.reduce(
    (s, a) => s + (Number(a?.priceWithDiscount || a?.price) || 0),
    0,
  );
}

export function computeCardSummary({
  svc,
  visitType,
  isExtraSlot,
  hasDiscountCard,
  psdf,
  additionalServices,
}) {
  const main = priceForService({
    svc,
    visitType,
    isExtraSlot,
    hasDiscountCard,
    psdf,
  });
  const additionals = sumAdditionalServices(additionalServices);
  return { main, additionals, total: main + additionals };
}

/**
 * Checks if logged in user is not registerging child that is not linked to him.
 * @param {obj} userState from useUserState UserContext,
 * @param {obj} userInfo from RegistrationContext,
 *
 * @returns {boolean}
 */
export function IsIncorrectChild(userState, userInfo) {
  const contacts = userState?.contacts;
  const childId = userInfo?.patientPersonalCode;

  if (contacts?.length && childId) {
    const found = contacts.some((x) => x.personalCode === childId);
    return !found;
  }

  return false;
}
